module.exports = __webpack_public_path__ + "img/33-Nogal Toscana.jpg";